import type { RecentSurvey } from './types';
import type { RecentSurveyDto } from './dto';

export const mapRecentSurveysResponseDtoToModel = function mapRecentSurveysResponseDtoToModel(
  surveys: RecentSurveyDto[],
): RecentSurvey[] {
  if (!surveys) return [];

  return surveys.map(
    ({
      id,
      uuid,
      name,
      enabled,
      display_type: displayType,
      response_count: responseCount,
    }: RecentSurveyDto) => ({
      id,
      uuid,
      name,
      enabled,
      displayType,
      responseCount,
    }),
  );
};
